<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Notifications'"
        :buttons="[
          {
            title: 'Add Notifications',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      >
      </cardHead>
      <dataTable
        :name="'accounts'"
        ref="agGrid"
        :data="data"
        :columnDefs="columnDefs"
        @cellClicked="updateShow=$event.data"
      ></dataTable>
    </div>
  </div>
  <add v-if="addShow" @close="addShow = false" @add="data.push($event);$refs.agGrid.addRow([$event]);"></add>
  <update v-if="updateShow!=null" @close="updateShow = null" :setModel="updateShow" @Update="$refs.agGrid.changeRow('Id',$event);"></update>
</template>

<script>
import moment from "moment";
import add from "./upsert.vue";
import update from "./upsert.vue";
export default {
  name: "notification",
  components: { add,update },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Subject",
          field: "Subject",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Body",
          field: "Body",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Date",
          field: "Date",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 150,
          valueFormatter: function(params) {
            if (params.value == null) {
              return null;
            } else {
              return moment(new Date(params.value)).format(
                "DD.MM.YYYY HH:mm:ss"
              );
            }
          },
        },
        {
          headerName: "UserCount",
          field: "UserCount",
          enableRowGroup: true,
          filter: "agNumberColumnFilter",
          width: 110,
        },
        {
          headerName: "SawCount",
          field: "SawCount",
          enableRowGroup: true,
          filter: "agNumberColumnFilter",
          width: 110,
        },
        {
          headerName: "Active",
          width: 80,
          filter: false,
          field: "Active",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        }
      ],
      data: null,
      addShow: false,
      updateShow:null
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$appAxiosAdmin
        .get(`Notifications`, this.model)
        .then((response) => {
          this.data = response.data;
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    selectAllClick() {
      for (
        let index = 0;
        index < this.$refs.agGrid.gridApi.getDisplayedRowCount();
        index++
      ) {
        if (this.selectAll) {
          this.$refs.agGrid.changeRow("UserId", {
            ...this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data,
            selected: true,
          });
        } else {
          this.$refs.agGrid.changeRow("UserId", {
            ...this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data,
            selected: false,
          });
        }
      }
    }
  },
};
</script>
